import action from './action';

const Component = () => import('./Referrals');

export { Component, action };
